// Module
var code = "<tr class=noDomains><td colspan=3>You currently do not have any domains on your account.</td></tr> ";
// Exports
module.exports = code;